import axios from "axios";
import { IP_GEO_API_KEY } from "src/utils/constants";

// utils
import { getCurrentDate } from "src/utils/dateHelper";

// constants
import { BASE_URL } from "src/utils/constants";

// cache store
import configure from "src/utils/store";

function fetchUserLocation() {
  const response = axios({
    method: "get",
    url: `https://api.ipgeolocation.io/ipgeo?apiKey=${IP_GEO_API_KEY}`,
  });

  return response;
}

async function fetchCategoriesCache(_userID) {
  let data = {
    userID: _userID,
  };

  const api = await configure();

  const response = await api({
    method: "POST",
    url: `/Category`,
    data: data,
    params: data.categoryId,
  });

  return response;
}

async function fetchEventByCategoryCache(_data, isCached = true) {
  let now = getCurrentDate();
  let response = null;

  let data = {
    accessToken: "",
    latitude: _data.lat,
    longitude: _data.lng,
    categoryId: _data.catgId,
    dateTimeNow: now.prettier.dateTimeNow,
    totalPageCount: _data?.limit || 12,
    pageNumber: _data?.pageNumber || 1,
    sortOrder: "distance",
    isFromWeb: "1",
  };

  if (isCached) {
    const api = await configure();
    response = await api({
      method: "POST",
      url: `/NewEvent`,
      data: data,
      params: data.categoryId,
    });
  } else {
    response = axios({
      method: "POST",
      url: `${BASE_URL()}/NewEvent`,
      data: data,
    });
  }

  return response;
}

async function clearCache() {
  const api = await configure();
  api.cache.clear();
}

async function clearCacheCategory(_id) {
  const api = await configure();
  api.cache.removeItem(_id);
}

async function fetchSearchEvents(_searchText, _location) {
  let now = getCurrentDate();
  console.log({ _location });
  let data = {
    SearchText: _searchText,
    Latitude: _location.latitude,
    LongiTude: _location.longitude,
    Date: now.prettier.dateTimeNow,
  };

  const response = await axios({
    method: "POST",
    url: `${BASE_URL()}/SearchBar`,
    data: data,
  });

  return response;
}

export {
  fetchUserLocation,
  fetchCategoriesCache,
  fetchEventByCategoryCache,
  clearCache,
  clearCacheCategory,
  fetchSearchEvents,
};
